import React from 'react'

import i18n from 'i18n'

import { OmTabs } from '@owma/kit'

import classNames from 'classnames'
import { i18Key } from 'utils'
// import { notImplemented } from 'utils/ui'

import { UIGroup, ViewGroup } from 'utils/ui/propsUI'
import { isSameDavUrl, toDavPath } from 'libs/dav/davPath'

import settings from '../index'
import styles from './style.module.scss'

import CustomTimeSelector from 'pages/calendar/components/EventEditor/CustomTimeSelector'
import moment from 'moment'
import * as dateUtils from 'pages/calendar/utils/DateUtils'
import FolderSelector from 'pages/todo/components/TodoEditor/FolderSelector'
import { SettingsInterface } from '../def'

// TodoService 모듈 동적 로딩
// TodoService 내에서 settings 모듈을 사용하기 때문에 나중에 로딩되도록 수정.
// 이부분 import 타이밍은 초기 접속시에 loading 되므로 실제 Setting UI 가 나타날때는 문제가 되지 않음.
let todoService: any = null
import('pages/todo/modules/TodoService').then((module) => {
  todoService = module
})

interface TodoSettingsProps {
  innerRef?: React.MutableRefObject<SettingsInterface | null>
  owner: any
  isMobile?: boolean
  parentLabel?: any
  idx?: string
}

interface TodoSettingsState {}

class SettingItem
  extends React.Component<TodoSettingsProps, TodoSettingsState>
  implements SettingsInterface
{
  state: TodoSettingsState = {}

  uiGroupMap: Record<string, UIGroup> = {}

  vGroupMap: Record<string, ViewGroup[]> = {}

  curValueMap: any = {}

  isUICreated: boolean = false

  editEventData: any = null

  componentDidMount(): void {
    const { innerRef } = this.props
    if (innerRef != null) {
      innerRef.current = this
    }
    this.applySettings()
  }

  // componentDidUpdate(prevProps) {
  //   const { mailbox, selectedEmail } = this.props
  // }

  componentWillUnmount(): void {}

  getReminderDefaultTime = (value: number): string => {
    const currentDate = new Date()
    const hour = Math.floor(value / 60)
    const minute = value % 60
    currentDate.setHours(hour || 9, minute || 0, 0, 0)
    return dateUtils.localizedTimeString(currentDate)
  }

  getCustomReminderStartTime = (value: number): any => {
    const currentDate = new Date()
    const hour = Math.floor(value / 60)
    const minute = value % 60
    currentDate.setHours(hour || 9, minute || 0, 0, 0)

    if (this.editEventData?.startDate !== currentDate) {
      this.editEventData = {
        startDate: currentDate,
        endDate: currentDate,
        startTz: moment.tz.guess(),
        endTz: moment.tz.guess(),
        isMyEvent: true,
        isAllDay: false,
      }
    }

    return {
      onGetValue: (info: any, wrapper: any) => {
        console.log('customReminderStartTime onGetValue : ', wrapper, info)
      },

      getElement: (info: any, wrapper: any) => {
        const { reactObj } = wrapper
        // const { owner } = reactObj.props
        return (
          <div className={styles.customReminderStartTime}>
            <CustomTimeSelector
              timing="start"
              onTimeChange={(timeStr: string) => {
                console.log('handleCustomTimeChange called with:', timeStr)

                // timeStr은 "HH:MM" 형식 (24시간)
                const [hours, minutes] = timeStr.split(':')
                const newDateTime = new Date(currentDate)
                const h = parseInt(hours)
                const m = parseInt(minutes)
                newDateTime.setHours(h, m)

                reactObj.onPropsChange('defaultReminderStartTime', h * 60 + m)
              }}
              editEventData={this.editEventData}
              defaultValue={dateUtils.localizedTimeString(currentDate)}
            />
          </div>
        )
      },
    }
  }

  getCustomFolder = (folderId: string | null): any => {
    const folders = todoService.getSortedFoldersProxy()
    // folderId 는 settings 에 저장된 path(구버전은 절대 URL) 이므로 host 를 무시하고 비교한다.
    let selectedFolder =
      folderId == null ? null : folders.find((f: any) => isSameDavUrl(f.url, folderId)) //default folder

    return {
      onGetValue: (info: any, wrapper: any) => {
        console.log('customFolder onGetValue : ', wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any) => {
        console.log('customContactSelect onSetValue : ', wrapper, info, value)
        console.log('selectedFolder : ', selectedFolder)
      },
      getElement: (info: any, wrapper: any) => {
        const { reactObj } = wrapper
        return (
          <div className={styles.customFolderSelector}>
            <FolderSelector
              selectedFolder={selectedFolder}
              folders={folders}
              disabled={false}
              onFolderChange={(folder: any) => {
                // settings 에는 host 를 제거한 path 로 저장한다.
                reactObj.onPropsChange('defaultFolder', folder?.url ? toDavPath(folder.url) : null)
                selectedFolder = folder
              }}
              settingType="todo"
            />
          </div>
        )
      },
    }
  }

  createUIGroup = (): void => {
    if (this.isUICreated === true) {
      return
    }

    this.isUICreated = true

    this.createGeneralUIGroup()
  }

  createGeneralUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: i18Key('settings.subtitle.defaultValuesTodo'),
        desc: null,
      }),
    ]
    const { t } = i18n

    const clone = settings.getAll()

    const uiProps = {
      defaultReminderStartTime: {
        labelKey: i18Key('settings.fields.calReminderTime'),
        readOnly: false,
        format: 'custom',
        ...this.getCustomReminderStartTime(clone.todo.defaultReminderStartTime || 540),
        default: 540,
        vGroup: vGroups[0],
      },
      defaultReminderTimeForToday: {
        labelKey: i18Key('settings.todoTabs.reminderTimeForToday'),
        readOnly: false,
        format: 'om-select',
        default: 0,
        values: [
          { value: 0, labelKey: i18Key('settings.todoTabs.auto') },
          { value: 10, labelKey: i18Key('settings.todoTabs.10MinutesLater') },
          { value: 30, labelKey: i18Key('settings.todoTabs.30MinutesLater') },
          { value: 60, labelKey: i18Key('settings.todoTabs.1HourLater') },
          { value: 120, labelKey: i18Key('settings.todoTabs.2HoursLater') },
        ],
        vGroup: vGroups[0],
      },
      defaultReminderTimeForFuture: {
        labelKey: i18Key('settings.todoTabs.reminderTimeForFuture'),
        readOnly: false,
        format: 'om-select',
        default: 'dueDate',
        values: [
          {
            value: 'dueDate',
            labelKey: t('settings.todoTabs.dayOfDueAt', {
              time: this.getReminderDefaultTime(clone.todo.defaultReminderStartTime || 540),
            }),
          },
          {
            value: 'dayBefore',
            labelKey: t('settings.todoTabs.dayBeforeDueAt', {
              time: this.getReminderDefaultTime(clone.todo.defaultReminderStartTime || 540),
            }),
          },
          {
            value: 'weekBefore',
            labelKey: t('settings.todoTabs.weekBeforeDueAt', {
              time: this.getReminderDefaultTime(clone.todo.defaultReminderStartTime || 540),
            }),
          },
        ],
        vGroup: vGroups[0],
      },
      defaultDueDate: {
        labelKey: i18Key('todo.todolist.dueDate'),
        readOnly: false,
        format: 'om-select',
        default: 'no-date',
        values: [
          { value: 'today', labelKey: i18Key('todo.todolist.today') },
          { value: 'tomorrow', labelKey: i18Key('todo.todolist.tomorrow') },
          { value: 'no-date', labelKey: i18Key('todo.todolist.noDate') },
        ],
        vGroup: vGroups[0],
      },
      defaultFolder: {
        labelKey: i18Key('todo.editor.folder'),
        readOnly: false,
        format: 'custom',
        ...this.getCustomFolder(clone.todo.defaultFolder),
        default: null,
        vGroup: vGroups[0],
      },
    }

    this.vGroupMap.general = vGroups

    this.uiGroupMap.general = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  applySettings = (): void => {
    const clone = settings.getAll()
    this.curValueMap = {
      defaultReminderStartTime: clone.todo.defaultReminderStartTime,
      defaultReminderTimeForToday: clone.todo.defaultReminderTimeForToday,
      defaultReminderTimeForFuture: clone.todo.defaultReminderTimeForFuture,
      defaultDueDate: clone.todo.defaultDueDate,
      defaultFolder: clone.todo.defaultFolder,
    }
    Object.keys(this.uiGroupMap).forEach((key) => {
      this.uiGroupMap[key].setValue(clone.todo, true)
    })
  }

  onPropsChange = (key: string, value: any): void => {
    // console.log(' --- onPropsChange : ', key, value)

    const { owner } = this.props
    const orgValues = { ...owner.defaultValues.todo, ...owner.newValues.todo }

    orgValues[key] = value

    if (owner != null && owner.onChangeValue != null) {
      owner.onChangeValue('todo', { ...orgValues })
    }
  }

  getTabsAttrs = (): any => {
    const { owner, isMobile, parentLabel, idx } = this.props
    const { t } = i18n

    if (this.isUICreated === false) {
      this.createUIGroup()
    }

    let defaultActiveKey: string | null = null
    const { selectedTabs } = owner
    if (selectedTabs != null && selectedTabs.length > 1) {
      defaultActiveKey = selectedTabs[1]
    }

    const items = [
      {
        key: 'general',
        label: (
          <div className={classNames('tabItem', 'general', styles.general)}>
            <div className={classNames(styles.label)}>{t('settings.calendarTabs.general')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'general', styles.general)}>
            {this.uiGroupMap.general.getElement()}
          </div>
        ),
      },
    ]

    const tabsAttrs: any = {
      className: classNames('subTabs'),
      items,
      centered: true,
      tabPosition: 'left' as const,
      tabBarExtraContent: isMobile ? { left: parentLabel } : null,
      // onChange: (activeKey) => {
      // },
      onTabClick: (activeKey: string) => {
        const item = items.find((item) => item.key === activeKey)
        if (item != null) {
          const index = parseInt(idx as string, 10)
          owner.mobileViewObj.setKey(1, activeKey, [parentLabel, item.label], index)
        }
      },
    }

    if (defaultActiveKey != null) {
      tabsAttrs.defaultActiveKey = defaultActiveKey
    }

    return tabsAttrs
  }

  render(): React.ReactNode {
    const tabsAttrs = this.getTabsAttrs()

    return (
      <div className={classNames(styles.todo)}>
        <OmTabs {...tabsAttrs} />
      </div>
    )
  }
}

export default SettingItem
